import React, { useState } from "react";
import "./drug_chart.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import headerimage from "../../assets/images/ascas.svg";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";
export default function DrugChart(props) {
  const [valueChange, setvalueChange] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  const [rows, setRows] = useState([
    {
      sno: "",
      medication: "",
      dosage: "",
      frequency: "",
      timing: "",
      route: "",
      days: "",
    },
  ]);
  console.log(rows);

  const handleAddRow = (index) => {
    setRows([
      ...rows,
      {
        sno: "",
        medication: "",
        dosage: "",
        frequency: "",
        timing: "",
        route: "",
        days: "",
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const newRows = rows.filter((row, i) => i !== index);
    setRows(newRows);
  };

  const handleChange = (index, e) => {
    if (e.target.name !== "nextappointment") {
      const { name, value } = e.target;
      const newRows = [...rows];
      newRows[index][name] = value;
      setRows(newRows);
    }
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
      });
    }
  };

  const handleChangeid = (e) => {
    // const { name, value } = e.target;
    // setvalueChange({ ...valueChange, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    }
  };
  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Drug Chart",
            },
          };

          // Dispatch action to create patient report
          // props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            // props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    // props.loaderchange("false");
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };

  return (
    <div id="drugchart">
      <div className="drugchart">
        <h1>DRUG CHART</h1>
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: "3px",
            backgroundColor: "#f7f7f7 ",
            borderRadius: "6px",
            padding: "16px 8px 16px 8px",
            gap: "3px",
          }}
        > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient ID</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                value={valueChange.patientId1}
                onChange={(e) => handleChangeid(e)}
                name="patientId1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.patientId1}
              </span>
            </div>
          </div> */}

          {/* Patient Name */}
          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center ",
            }}
          >
            <span style={{ fontWeight: 600 }}>Patient Name</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              value={valueChange.patientName1}
              name="patientName1"
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
                color: "#000",
              }}
            />
            <span
              className={`input ${!show ? "hide" : "show"}`}
              style={{ width: "100%" }}
            >
              &nbsp;{valueChange.patientName1}
            </span>
          </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Gender</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.gender1}
                name="gender1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Others">Others</option>
                <option value="Decline to State">Decline to State</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.gender1}
              </span>
            </div>
          </div> */}

          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center ",
            }}
          >
            <span style={{ fontWeight: 600 }}>Age</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              value={valueChange.age1}
              name="age1"
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
              }}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.age1}
            </span>
          </div> */}

          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center",
              // paddingLeft: "25px",
            }}
          >
            <span style={{ fontWeight: 600 }}>Blood Group</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              name="bloodGroup1"
              value={valueChange.bloodGroup1}
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
                backgroundColor: "white",
              }}
            >
              <option value="" disabled selected>
                Select Blood Group
              </option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.bloodGroup1}
            </span>
          </div> */}
          {/* </div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={valueChange.gender1}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <thead>
            <tr>
              <th>SNO</th>
              <th className="medication">MEDICATIONS</th>
              <th>DOSAGE</th>
              <th>FREQUENCY</th>
              <th>TIMING</th>
              <th>ROUTE</th>
              <th>DAYS</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="sno"
                    value={row.sno}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.sno}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="medication"
                    value={row.medication}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.medication}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="dosage"
                    value={row.dosage}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.dosage}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="frequency"
                    value={row.frequency}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.frequency}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="timing"
                    value={row.timing}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.timing}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="route"
                    value={row.route}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.route}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="days"
                    value={row.days}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.days}
                  </span>
                </td>
                <td>
                  {index == 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={(e) => handleAddRow(index)}
                    >
                      +
                    </button>
                  )}
                  {index > 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={() => handleRemoveRow(index)}
                    >
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* <p style={{ textAlign: "center", padding: "30px 10px" }}>
          x x x End Of Report x x x
        </p> */}

        <p style={{ fontWeight: "600" }}>
          NEXT APPOINTMENT -{" "}
          <input
            name="nextappointment"
            onChange={(e) => handleChange("no", e)}
            type="datetime-local"
            // type="date"
          />
        </p>
        <div className="Footer">
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <table style={{ width: "100%" }}>
              <thead>
                {[
                  "SI No.",
                  "MEDICATIONS",
                  "DOSAGE",
                  "FREQUENCY",
                  "TIMING",
                  "ROUTE",
                  "DAYS",
                ].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                {rows.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.sno)}
                      {renderTableTD(ele.medication)}
                      {renderTableTD(ele.dosage)}
                      {renderTableTD(ele.frequency)}
                      {renderTableTD(ele.timing)}
                      {renderTableTD(ele.route)}
                      {renderTableTD(ele.days)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment : ",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
